// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box{
    background-color: skyblue;
    border-radius: 0 30px;
    overflow: hidden;
    position: relative;
    z-index: 1;
    transition: all 0.3s ease 0.3s;
}
.box:hover{ background-color:#0441a3; }
.box:before,
.box:after,
.box .box-content:before,
.box .box-content:after{
    content: '';
    background-color:#0441a3;
    width: 100%;
    height: 5px;
    position: absolute;
    top: 0;
    transition: all 0.4s ease-in;
}
.box:hover .box-front{
    opacity: 0;
}

.box:after{
    top: auto;
    bottom: 0;
    left: 100%;
}
.box .box-content:before{
    width: 5px;
    height: 100%;
    top: 100%;
    left: 0;
}
.box .box-content:after{
    width: 5px;
    height: 100%;
    top: -100%;
    left: auto;
    right: 0;
}
.box:hover:before,
.box:hover:after{
    opacity: 0.2;
    left: 0;
}
.box:hover .box-content:before,
.box:hover .box-content:after{
    opacity: 0.2;
    top: 0;
}
.box img{
    width: 100%;
    height: auto;
    transition: all 0.3s ease;
}
.box:hover img{ opacity: 0.35; }
.box .box-content{
    color: #fff;
    height: 100%;
    width: 100%;
    padding: 15px 0 0 15px;
    opacity: 0;
    position: absolute;
    top: 20px;
    left: 0;
    transition: all 0.45s ease;
}
.box:hover .box-content{
    opacity: 1;
    top: 0;
}
.box .title{
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    text-shadow: 0 0 10px rgba(0,0,0,0.5);
    margin: 0 0 4px;
}
.box .post{
    font-size: 16px;
    letter-spacing: 1px;
    text-transform: lowercase;
    text-shadow: 0 0 10px rgba(0,0,0,0.5);
    margin: 0 0 5px;
    display: block;
}
.box .icon{
    padding: 0;
    margin: 0;
    list-style: none;
    opacity: 0;
    transform: rotate(-45deg);
    position: absolute;
    bottom: 15px;
    right: 15px;
    transition: all 0.4s cubic-bezier(0.6, -0.8, 0.735, 0.045);
}
.box:hover .icon{
    opacity: 1;
    transform: rotate(0deg);
}
.box .icon li{ display: inline-block;  }
.box .icon li a{
    color: #fff;
    background-color: #44bd32;
    font-size: 16px;
    text-align: center;
    line-height: 38px;
    width: 40px;
    height: 40px;
    margin: 0 5px;
    border-radius: 50%;
    border: 2px solid #fff;
    display: block;
    position: relative;
    transition: all 0.3s ease 0s;
}
.box .icon li  a:hover{ box-shadow: 0 0 15px rgba(0,0,0,0.5); }
.box .icon li  a:hover:after{
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    animation: animate 0.5s ease-out 75ms;
}
@keyframes animate{
    0%{ opacity: 0.3; }
    40%{
        opacity: 0.5;
        box-shadow: 0 0 0 2px rgba(255,255,255,0.1), 0 0 10px 10px #fff, 0 0 0 10px rgba(255,255,255,0.5);
    }
    100%{
        box-shadow: 0 0 0 2px rgba(255,255,255,0.1), 0 0 10px 10px #fff, 0 0 0 10px rgba(255,255,255,0.5);
        transform: scale(1.5);
        opacity: 0;
    }
}
@media only screen and (max-width:990px){
    .box { margin: 0 0 30px; }
}`, "",{"version":3,"sources":["webpack://./src/components/animatedcard.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,8BAA8B;AAClC;AACA,YAAY,wBAAwB,EAAE;AACtC;;;;IAII,WAAW;IACX,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,4BAA4B;AAChC;AACA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;IACT,SAAS;IACT,UAAU;AACd;AACA;IACI,UAAU;IACV,YAAY;IACZ,SAAS;IACT,OAAO;AACX;AACA;IACI,UAAU;IACV,YAAY;IACZ,UAAU;IACV,UAAU;IACV,QAAQ;AACZ;AACA;;IAEI,YAAY;IACZ,OAAO;AACX;AACA;;IAEI,YAAY;IACZ,MAAM;AACV;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;AACA,gBAAgB,aAAa,EAAE;AAC/B;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,0BAA0B;AAC9B;AACA;IACI,UAAU;IACV,MAAM;AACV;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,qCAAqC;IACrC,eAAe;AACnB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,qCAAqC;IACrC,eAAe;IACf,cAAc;AAClB;AACA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,0DAA0D;AAC9D;AACA;IACI,UAAU;IACV,uBAAuB;AAC3B;AACA,eAAe,qBAAqB,GAAG;AACvC;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,4BAA4B;AAChC;AACA,wBAAwB,oCAAoC,EAAE;AAC9D;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,qCAAqC;AACzC;AACA;IACI,IAAI,YAAY,EAAE;IAClB;QACI,YAAY;QACZ,iGAAiG;IACrG;IACA;QACI,iGAAiG;QACjG,qBAAqB;QACrB,UAAU;IACd;AACJ;AACA;IACI,OAAO,gBAAgB,EAAE;AAC7B","sourcesContent":[".box{\r\n    background-color: skyblue;\r\n    border-radius: 0 30px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    z-index: 1;\r\n    transition: all 0.3s ease 0.3s;\r\n}\r\n.box:hover{ background-color:#0441a3; }\r\n.box:before,\r\n.box:after,\r\n.box .box-content:before,\r\n.box .box-content:after{\r\n    content: '';\r\n    background-color:#0441a3;\r\n    width: 100%;\r\n    height: 5px;\r\n    position: absolute;\r\n    top: 0;\r\n    transition: all 0.4s ease-in;\r\n}\r\n.box:hover .box-front{\r\n    opacity: 0;\r\n}\r\n\r\n.box:after{\r\n    top: auto;\r\n    bottom: 0;\r\n    left: 100%;\r\n}\r\n.box .box-content:before{\r\n    width: 5px;\r\n    height: 100%;\r\n    top: 100%;\r\n    left: 0;\r\n}\r\n.box .box-content:after{\r\n    width: 5px;\r\n    height: 100%;\r\n    top: -100%;\r\n    left: auto;\r\n    right: 0;\r\n}\r\n.box:hover:before,\r\n.box:hover:after{\r\n    opacity: 0.2;\r\n    left: 0;\r\n}\r\n.box:hover .box-content:before,\r\n.box:hover .box-content:after{\r\n    opacity: 0.2;\r\n    top: 0;\r\n}\r\n.box img{\r\n    width: 100%;\r\n    height: auto;\r\n    transition: all 0.3s ease;\r\n}\r\n.box:hover img{ opacity: 0.35; }\r\n.box .box-content{\r\n    color: #fff;\r\n    height: 100%;\r\n    width: 100%;\r\n    padding: 15px 0 0 15px;\r\n    opacity: 0;\r\n    position: absolute;\r\n    top: 20px;\r\n    left: 0;\r\n    transition: all 0.45s ease;\r\n}\r\n.box:hover .box-content{\r\n    opacity: 1;\r\n    top: 0;\r\n}\r\n.box .title{\r\n    font-size: 22px;\r\n    font-weight: 700;\r\n    letter-spacing: 1px;\r\n    text-transform: uppercase;\r\n    text-shadow: 0 0 10px rgba(0,0,0,0.5);\r\n    margin: 0 0 4px;\r\n}\r\n.box .post{\r\n    font-size: 16px;\r\n    letter-spacing: 1px;\r\n    text-transform: lowercase;\r\n    text-shadow: 0 0 10px rgba(0,0,0,0.5);\r\n    margin: 0 0 5px;\r\n    display: block;\r\n}\r\n.box .icon{\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n    opacity: 0;\r\n    transform: rotate(-45deg);\r\n    position: absolute;\r\n    bottom: 15px;\r\n    right: 15px;\r\n    transition: all 0.4s cubic-bezier(0.6, -0.8, 0.735, 0.045);\r\n}\r\n.box:hover .icon{\r\n    opacity: 1;\r\n    transform: rotate(0deg);\r\n}\r\n.box .icon li{ display: inline-block;  }\r\n.box .icon li a{\r\n    color: #fff;\r\n    background-color: #44bd32;\r\n    font-size: 16px;\r\n    text-align: center;\r\n    line-height: 38px;\r\n    width: 40px;\r\n    height: 40px;\r\n    margin: 0 5px;\r\n    border-radius: 50%;\r\n    border: 2px solid #fff;\r\n    display: block;\r\n    position: relative;\r\n    transition: all 0.3s ease 0s;\r\n}\r\n.box .icon li  a:hover{ box-shadow: 0 0 15px rgba(0,0,0,0.5); }\r\n.box .icon li  a:hover:after{\r\n    content: \"\";\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    animation: animate 0.5s ease-out 75ms;\r\n}\r\n@keyframes animate{\r\n    0%{ opacity: 0.3; }\r\n    40%{\r\n        opacity: 0.5;\r\n        box-shadow: 0 0 0 2px rgba(255,255,255,0.1), 0 0 10px 10px #fff, 0 0 0 10px rgba(255,255,255,0.5);\r\n    }\r\n    100%{\r\n        box-shadow: 0 0 0 2px rgba(255,255,255,0.1), 0 0 10px 10px #fff, 0 0 0 10px rgba(255,255,255,0.5);\r\n        transform: scale(1.5);\r\n        opacity: 0;\r\n    }\r\n}\r\n@media only screen and (max-width:990px){\r\n    .box { margin: 0 0 30px; }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
